import { defineStore } from 'pinia';
import GroupTypeService from '@/service/GroupTypeService';
const groupTypeService = new GroupTypeService();
export const useGroupTypeStore = defineStore('groupTypeManagement', {
  state: () => ({}),
  getters: {},
  actions: {
    getGroupTypeList() {
      return groupTypeService.getGroupTypeList();
    },
    getGroupTypeManagementList() {
      return groupTypeService.getGroupTypeManagementList();
    },
    getGroupTypeDetail(id) {
      return groupTypeService.getGroupTypeDetail(id);
    },
    addGroupType(payload) {
      return groupTypeService.addGroupType(payload);
    },
    deleteGroupType(id) {
      return groupTypeService.deleteGroupType(id);
    },
    updateStatus(id, status) {
      return groupTypeService.updateStatus(id, status);
    },
    updateStatusInstaQuote(id, instaQuote) {
      return groupTypeService.updateStatusInstaQuote(id, instaQuote);
    }
  }
});
